import { SolutionPodType } from "@/@types/types";
import { Layout } from "@/components/Layout";
import { Breadcrumb } from "@/components/Shared/Breadcrumb";
import React from "react";
import SEO, { SEOType } from "../SEO";
import { ServiceCard } from "../Services/service-card";

interface SolutionsProps {
  solutions: SolutionPodType[];
  seo: SEOType;
}

interface SolutionsState {
  activeFilter: string;
  categories: string[];
}

export default class Solutions extends React.Component<SolutionsProps, SolutionsState> {
  constructor(props: SolutionsProps) {
    super(props);
    this.state = {
      activeFilter: "All Solutions",
      categories: this.collectCategories(props.solutions),
    };
  }

  collectCategories(solutions: SolutionPodType[]): string[] {
    const cats = new Set<string>();
    solutions.forEach((s) => {
      if (s.category) {
        cats.add(s.category);
      }
    });
    return ["All Solutions", ...Array.from(cats)];
  }

  handleFilterChange = (filter: string) => {
    this.setState({ activeFilter: filter });
  };

  render(): JSX.Element {
    const { solutions, seo } = this.props;
    const { activeFilter, categories } = this.state;

    const filteredSolutions =
      activeFilter === "All Solutions"
        ? solutions
        : solutions.filter((s) => s.category === activeFilter);

    return (
      <Layout>
        <SEO
          contentfulSeo={seo}
          breadcrumbRoutes={[
            { name: "Home", path: "/" },
            { name: "Solutions", path: "/solutions/" },
          ]}
        />
        <Breadcrumb
          currentPageTitle="Zartek Solutions"
          routes={[
            { path: "/", title: "Home" },
            { path: "/solutions/", title: "Solutions" },
          ]}
        />

        <div className="page-bottom pbottom-70 pt-4">
          <div className="container">
            {/* <PortfolioFilters
              filters={categories}
              activeFilter={activeFilter}
              onFilterChange={this.handleFilterChange}
            /> */}
            <div className="row pt-3">
              {filteredSolutions.map(({ slug, id, icon, solutionDescription, solutionTitle }) => {
                return (
                  <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={id}>
                    <ServiceCard
                      description={solutionDescription}
                      icon={icon}
                      title={solutionTitle}
                      routerLink={"/" + slug}
                    />
                  </div>
                );
              })}
            </div>
            {filteredSolutions.length === 0 && (
              <div className="text-center w-100 py-5">
                <p>No solutions found in this category.</p>
              </div>
            )}
          </div>
        </div>
      </Layout>
    );
  }
}
